import { HomePageResponse } from '../../../api/types/adviewApiTypes';
import { VERTICAL } from '../../../helpers/verticals';
import type { Dispatch, SetStateAction } from 'react';

type ListItem = {
  value: string;
  displayName: string;
  group?: string;
};

export function handleSelectLocation(
  selectedLocations: ListItem[],
  setAreas: Dispatch<SetStateAction<ListItem[]>>,
  onMarketPlaceLocation: (t: string[]) => void,
  setLocationDisplay: Dispatch<SetStateAction<string>>,
) {
  if (selectedLocations.length === 0) {
    setAreas([]);
    onMarketPlaceLocation([]);
    setLocationDisplay('');
  } else {
    setAreas(selectedLocations);
    onMarketPlaceLocation(selectedLocations.map((area) => area.value));
    setLocationDisplay(
      `${selectedLocations[0].displayName}${
        selectedLocations.length > 1
          ? ` (+${selectedLocations.length - 1})`
          : ''
      }`,
    );
  }
}

export function handleApplyLocations(
  selectedLocations: ListItem[],
  onMarketPlaceLocation: (t: string[]) => void,
  setIsLocationBottomSheetOpen: (t: boolean) => void,
  setIsLocationOpen: (t: boolean) => void,
) {
  onMarketPlaceLocation(selectedLocations.map((area) => area.value));
  setIsLocationBottomSheetOpen(false);
  setIsLocationOpen(false);
}

export type HomePageData = {
  sectionsTitle: string;
  sections: HomePageResponse['sections'];
  featuredAds: HomePageResponse['featuredDealer'];
  recentAds: HomePageResponse['recentAds'];
  recentAdsUrl: HomePageResponse['recentAdsUrl'];
  adCount: HomePageResponse['adCount'];
  dashLinks: HomePageResponse['dashLinks'];
  dataTargetingProps: HomePageResponse['dataTargetingProps'];
  seoLinks: HomePageResponse['seoLinks'];
  lifestyleLinks: HomePageResponse['lifestyleLinks'];
  vertical: VERTICAL;
};

export function transformHomePageResponse(
  response: HomePageResponse,
): HomePageData {
  return {
    sectionsTitle: getSectionsTitle(response.siteFocus),
    sections: response.sections,
    featuredAds: response.featuredDealer ?? null,
    recentAds: response.recentAds,
    recentAdsUrl: response.recentAdsUrl,
    adCount: response.adCount,
    dashLinks: response.dashLinks,
    dataTargetingProps: response.dataTargetingProps,
    seoLinks: response.seoLinks,
    lifestyleLinks: response.lifestyleLinks ?? [],
    vertical: response.siteFocus,
  };
}

const H1 = {
  /**
   * @warning Used by Pingdom to check if the site is up.
   * If you change this string, please inform SRE.
   */
  MOTOR: 'Browse by category',
  MARKETPLACE: 'Buy & Sell Locally in Ireland',
  FARMING: 'Buy & Sell Farm Machinery & Tractors',
};

const getSectionsTitle = (vertical: VERTICAL): string => {
  switch (vertical) {
    case VERTICAL.MOTOR:
      return H1.MOTOR;
    case VERTICAL.MARKETPLACE:
      return H1.MARKETPLACE;
    case VERTICAL.FARMING:
      return H1.FARMING;
    default:
      return H1.MARKETPLACE;
  }
};
